/* File to manage the endpoints of various URLs */

const developmentFrontEndHostName = 'http://localhost:3000';
const productionFrontEndHostName = 'anime-manager-v2.netlify.app';
const developmentBackEndHostName = 'http://localhost:5000';
const productionBackEndHostName = 'https://anime-manager-v2.herokuapp.com';
const API_VERSION_ONE = 'v1';
export const ANIME_TOKEN = 'anime-token';

export const URL = {
  developmentBackEndHostName,
  developmentFrontEndHostName,
  productionBackEndHostName,
  productionFrontEndHostName,
  API_VERSION_ONE,
};
